/** 3 Nov 2026 (D-1103-SIMPLE): is "Simpler screens" on? One read of the Day plan settings every role already gets; on unless the row says No. */
import { simplerScreensOn } from '@shared/simpler-1103';
import { useDayPlan } from '@/lib/queries';

export function useSimplerScreens(): boolean {
  return simplerScreensOn(useDayPlan().data?.settings);
}
